// src/function/isProductVisible.js

export default function isProductVisible(product) {
  if (!product) return false;

  const value = product.productVisible;

  // Старі товари без цього поля залишаємо видимими
  if (value === undefined || value === null) {
    return true;
  }

  return value !== false && value !== "false" && value !== 0 && value !== "0";
}
